import React, { useState, useEffect } from 'react'
import { Checkbox, Loader, Message, Table } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import PopoverMessages from '../../components/message/PopoverMessages'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import { isEmpty } from 'lodash-es'

export default function AIEvaluationResultView({
  schema,
  // finalSubmitButton,
  // finalSubmitButtonText,
  // onSubmitFinalSubmitButton = () => {},
  onCheck = () => {},
  onContinue = () => {},
  showDetail = true,
  isSend,
}) {
  const { Column, HeaderCell, Cell } = Table

  const [isShowDetail, setIsShowDetail] = useState(showDetail)
  const [isContinue, setIsContinue] = useState()

  const isPass = (schema.score || 0) >= (schema?.minimumScore || 0)

  return (
    <>
      {schema && (
        <div>
          {schema.datas?.length > 0 ? (
            <>
              {/* {isSend && schema.statusMessage && (
                <div style={{ marginBottom: 20 }}>
                  <Message
                    type="warning"
                    showIcon
                    description={
                      <>
                        {schema.statusMessage}
                      </>
                    }
                  />
                  <EditButton
                    style={{ marginTop: 10 }}
                    icon="refresh"
                    children="ตรวจสอบ"
                    onClick={() => {
                      onCheck(schema.id)
                    }}
                  />
                </div>
              )} */}

              <p>
                <b>วันที่ประเมิน : {schema.evaluationDate}</b>
              </p>
              {/* {showTimes && (
            <p>
              <b>ครั้งที่ประเมิน : {schema.evaluationId}</b>
            </p>
          )} */}
              <b>
                คะแนนที่ได้ :{' '}
                <span
                  style={{
                    color: isPass ? '#2da888' : '#fb8a81',
                    fontSize: '1.5rem',
                  }}
                >
                  <span>{schema.score}</span> / <span>{schema?.totalScore}</span>
                </span>
              </b>
              <br />

              <div style={{ marginTop: 10 }}>
                {!isShowDetail ? (
                  <ViewButton
                    icon="angle-double-down"
                    children="แสดงรายระเอียด"
                    onClick={() => {
                      setIsShowDetail(true)
                    }}
                  />
                ) : (
                  <ViewButton
                    icon="angle-double-up"
                    children="ซ่อนรายระเอียด"
                    onClick={() => {
                      setIsShowDetail(false)
                    }}
                  />
                )}
              </div>
              {isShowDetail && (
                <Table
                  wordWrap
                  height={500}
                  data={schema.datas}
                  style={{ marginTop: 10 }}
                  // onRowClick={(data) => {
                  //   console.log(data)
                  // }}
                  //loading={isLoadingTable}
                >
                  <Column width={300} fixed>
                    <HeaderCell>
                      <span>หัวข้อ</span>
                    </HeaderCell>
                    <Cell>
                      {(rowData) => {
                        return (
                          <span>
                            <b>
                              {rowData.criteraiId}. {rowData.criteriaName}
                            </b>
                            <PopoverMessages
                              content={rowData.criteriaRule}
                              placement={'auto'}
                              maxHeight={500}
                              style={{ marginLeft: 10, color: '#2da888' }}
                            />
                          </span>
                        )
                      }}
                    </Cell>
                  </Column>

                  <Column width={120} align="right">
                    <HeaderCell>
                      <span>คะแนนเต็ม</span>
                    </HeaderCell>
                    <Cell dataKey="maxScore" />
                  </Column>

                  <Column width={120} align="right">
                    <HeaderCell>
                      <span>คะแนนที่ได้</span>
                    </HeaderCell>
                    <Cell dataKey="score" />
                  </Column>

                  <Column width={500} minWidth={250} flexGrow={1}>
                    <HeaderCell>
                      <span>เหตุผลในการให้คะแนน</span>
                    </HeaderCell>
                    <Cell>
                      {(rowData) => {
                        return (
                          <span
                            style={{
                              whiteSpace: 'pre-line',
                            }}
                          >
                            {rowData.explanation}
                          </span>
                        )
                      }}
                    </Cell>
                  </Column>
                  <Column width={250} minWidth={250} flexGrow={1}>
                    <HeaderCell>
                      <span>ความเห็น/ข้อเสนอแนะ</span>
                    </HeaderCell>
                    <Cell>
                      {(rowData) => {
                        return (
                          <span
                            style={{
                              whiteSpace: 'pre-line',
                            }}
                          >
                            {rowData.comments}
                          </span>
                        )
                      }}
                    </Cell>
                  </Column>
                </Table>
              )}
              {schema?.infoMsg && (
                <Message
                  style={{ marginTop: 10 }}
                  type="info"
                  showIcon
                  description={schema.infoMsg}
                />
              )}

              {isSend && isEmpty(schema.statusMessage) && (
                <>
                  {!isPass && (
                    <Checkbox
                      onChange={(_, checked) => {
                        setIsContinue(checked)
                        onContinue(checked)
                      }}
                      checked={isContinue}
                    >
                      {schema.continueMsg}
                    </Checkbox>
                  )}

                  {/* {(isPass || isContinue) && (
                    <SaveButton
                      style={{ marginTop: 10 }}
                      icon="send"
                      onClick={onSubmitFinalSubmitButton}
                      children={finalSubmitButtonText}
                    />
                  )} */}
                </>
              )}
            </>
          ) : (
            <Message showIcon description="ไม่มีผลการประเมินคะแนนข้อเสนอโครงการ" type="warning" />
          )}
        </div>
      )}
    </>
  )
}
